
<div class="dashBoardContainer">
  <div class="dashboard">
    <div class="actions">


      <mat-card class="blbk formupload">

        <div class="upDoc" (click)="openform()">
          <div class="uploadholder">
            <!-- <input #Input type="file" multiple /> -->
            <!-- <mat-icon>picture_as_pdf</mat-icon> -->
            <h2>Send Documents for signature</h2>
            <div class="textIn">
              <p>Click here to get Started</p>
            </div>
          </div>
        </div>

      </mat-card>
 

      <mat-card class="quickLinkTop">




        <div class="core listing">

          <div class="group">
            <div class="tabledata">

              <div class="icon_action">

                <button mat-icon-button color="primary" (click)="openPopup(AddLink)"><mat-icon>add</mat-icon></button>

                <!-- <button (click)="showHideQuickLink()" mat-icon-button color="warn"><mat-icon>delete</mat-icon></button> -->

              </div>

              <div class="linkIcon" *ngIf="quickLinkAPIArray">


                
                  <div class="forms" *ngIf="quickLinkAPIArray.forms">
                    <label>Forms</label>
                    <div class="" style="display: flex;" >
                      <ng-container *ngFor="let link of quickLinkAPIArray.forms; let last = last; let i = index;" >
                        <div class="iconHolder" [ngClass]="{ 'sep': last }">
                          <button class="showOnClick close" mat-icon-button color="warn" 
                            (click)="deleteQuickLink(link)"><mat-icon>clear</mat-icon></button>
      
                          <div class="formBtn" (click)="openProject(link)">
      
                            <button mat-icon-button [ngStyle]="{'background-color': link.color }">
                              <mat-icon>{{link.icon}}</mat-icon> </button>
                            <span matTooltip="{{ link.name }}">{{ link.name }}</span>
                          </div>
                        </div>
  
                      </ng-container>
                    </div>
                  </div>
                


               
                  <div class="url"  *ngIf="quickLinkAPIArray.urls">
                    <label>Url</label>
                    <div class="" style="display: flex;" >
                      <ng-container *ngFor="let link of quickLinkAPIArray.urls; let last = last; let i = index">
                      <div class="iconHolder" [ngClass]="{ 'sep': last }">
                        <button class="showOnClick close" mat-icon-button color="warn"
                          (click)="deleteQuickLink(link)"><mat-icon>clear</mat-icon></button>
    
                        <div class="formBtn" (click)="openExternalLink(link.url)">
    
                          <button mat-icon-button [ngStyle]="{'background-color': link.color }">
                            <mat-icon>{{link.icon}}</mat-icon> </button>
                          <span matTooltip="{{ link.name }}">{{ link.name }}</span>
                        </div>
                      </div>
                    </ng-container>
                    </div>                    
                  </div>


                  <div class="folder"  *ngIf="quickLinkAPIArray.folders" >
                    <label>Folder</label>
                    <div class="" style="display: flex;" >
                      <ng-container *ngFor="let link of quickLinkAPIArray.folders; let last = last">
                        <div class="iconHolder" [ngClass]="{ 'sep': last }">
                          <button class="showOnClick close" mat-icon-button color="warn"
                            (click)="deleteQuickLink(link)"><mat-icon>clear</mat-icon></button>
                          <div class="formBtn" (click)="openFilemanagerFolder(link)">
      
      
                            <button mat-icon-button [ngStyle]="{'background-color': link.color }" >
                              <mat-icon>{{link.icon}}</mat-icon> </button>
                            <span matTooltip="{{ link.name }}">{{ link.name }}</span>
                          </div>
                        </div>
                      </ng-container>
                    </div>                    
                  </div>
                  

                  <div class="folder"  *ngIf="quickLinkAPIArray.tasklists">
                    <label>Task List</label>
                    <div class="" style="display: flex;" >
                      <ng-container *ngFor="let link of quickLinkAPIArray.tasklists; let last = last">
                        <div class="iconHolder" [ngClass]="{ 'sep': last }">
                          <button class="showOnClick hideCrossBtn close" mat-icon-button color="warn"
                            (click)="deleteQuickLink(link)"><mat-icon>clear</mat-icon></button>
                          <div class="formBtn" (click)="OpenFolderSendEmail(SendTaskListURL,link)">
      
      
                            <button mat-icon-button [ngStyle]="{'background-color': link.color }" >
                              <mat-icon>{{link.icon}}</mat-icon> </button>
                            <span matTooltip="{{ link.name }}">{{ link.name }}</span>
                          </div>
                        </div>
                      </ng-container>
                    </div>                    
                  </div>
            

              </div>

            </div>
          </div>





        </div>


      </mat-card>


      

      <div class="blbk">
        <ng-container *ngFor="let link of menuModulesList">
          <mat-card class="infoTab">
            <div *ngIf="link.isAssign==true" class="info" (click)="redirect(link)">
              <h4>{{link.orgModuleName}}</h4>
              <!-- <span>{{link.note}}</span> -->
            </div>

            <div class="add" *ngIf="link.isAssign==true">
              <button *ngIf="link.orgModuleName!='Notes'" mat-icon-button color="primary"
                (click)="addNew(link)"><mat-icon>add</mat-icon></button>
              <button *ngIf="link.orgModuleName=='Notes'" mat-icon-button color="primary"
                (click)="addNotes(addNotesDialog)"><mat-icon>add</mat-icon></button>
            </div>
          </mat-card>
        </ng-container>
      </div>



    </div>
  </div>

  <div class="sepreatorHolder">


    <div class="recently">

      <mat-card class="threeCGraph">

        <div class="signatureGraph" *ngIf="coreSignatureGraphView">
          <div class="heading col">

            <div class="hview">
              <h3>Signature</h3>
              <div class="view">
                <button mat-icon-button [ngClass]="{'active': coreSignatureListView}"
                  (click)="showSignatureListView()"><mat-icon>list</mat-icon></button>
                <button mat-icon-button [ngClass]="{'active': !coreSignatureListView}"
                  (click)="showSignatureGraphView()"><mat-icon>insert_chart</mat-icon></button>
              </div>
            </div>
            <div class="view">
              <mat-form-field appearance="" class="smdropdown">
                <mat-select value="Week" (selectionChange)="SignatureOptionSelect($event)">
                  <mat-option value="Day">Day</mat-option>
                  <mat-option value="Week">Week</mat-option>
                  <mat-option value="Month">Month</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="graphHere" *ngIf="showSignaturegraph">
            <div id="chart">
              <apx-chart [series]="chartOptionspie.seriespie" [chart]="chartOptionspie.chart"
                [labels]="chartOptionspie.labels" [dataLabels]="chartOptionspie.dataLabels"
                [colors]="chartOptionspie.colors" [noData]="chartOptionspie.noData">
              </apx-chart>
            </div>


          </div>
        </div>

        <div class="signatureList listing" *ngIf="coreSignatureListView">
          <div class="heading col">
            <div class="hview">
              <h3>Signature</h3>
              <div class="view">
                <button mat-icon-button [ngClass]="{'active': coreSignatureListView}"
                  (click)="showSignatureListView()"><mat-icon>list</mat-icon></button>
                <button mat-icon-button [ngClass]="{'active': !coreSignatureListView}"
                  (click)="showSignatureGraphView()"><mat-icon>insert_chart</mat-icon></button>
              </div>
            </div>

            <div class="filter_field">
              <div class="view threeButtons">
                <button class="btn" [ngClass]="{'active': currentSignatureView == 'Inbox' }"
                  (click)="TypeSelection('Inbox')">Ready to sign</button>
                <button class="btn" [ngClass]="{'active': currentSignatureView == 'Sent' }"
                  (click)="TypeSelection('Sent')">Pending</button>
                <button class="btn" [ngClass]="{'active': currentSignatureView == 'Draft' }"
                  (click)="TypeSelection('Draft')">Draft</button>
              </div>
            </div>



          </div>

          <div class="group" *ngIf="ShowInbox">
            <div class="tabledata">
              <table cellspacing="0" cell padding="0">
                <tr>
                  <th class="sub bnone">Subject</th>
                  <th class="status bnone">Relation</th>
                  <th class="act bnone">Action</th>
                </tr>
                <ng-container *ngFor="let inbox of inboxProjectsList; let inboxIndex = index">
                  <ng-container *ngIf="(inbox.status == 0 || inbox.status == 2) && inboxIndex <= 3">
                    <tr>
                      <td class="sub">
                        <div class="cUsrImg">
                          <span>{{ inbox.subject }}</span>
                        </div>
                      </td>
                      <td class="status">
                        {{ inbox.relationName }}
                      </td>
                      <td class="act">
                        <a *ngIf="inbox.status==0" mat-icon-button matTooltipClass="tooltip" target="_blank" [href]='inbox.signHref'
                          matTooltip="Sign" color="primary">
                          <mat-icon>border_color</mat-icon>
                        </a>

                         <a *ngIf="inbox.status==2" mat-icon-button matTooltipClass="tooltip" target="_blank" [href]='inbox.signHref'
                          matTooltip="Approve" color="primary">
                          <mat-icon>check_circle</mat-icon>
                        </a>

                      </td>
                    </tr>
                  </ng-container>
                  <tr *ngIf="(inbox.status == 0 || inbox.status == 2) && inboxIndex == 4">

                    <td colspan="3" class="viewall">
                      <a [routerLink]="'/esignature/inbox'">View all</a>
                    </td>

                  </tr>
                </ng-container>

                <tr *ngIf="noRecordFoundInbox">
                  <td class="noRecordFound" colspan="3">No Record Found</td>
                </tr>
              </table>
            </div>
          </div>

          <div class="group" *ngIf="ShowSent">
            <div class="tabledata">
              <table cellspacing="0" cellpadding="0">
                <tr>
                  <th class="sub bnone">Subject</th>
                  <th class="status bnone">Status</th>
                  <th class="act bnone">Action</th>
                </tr>
                <ng-container *ngFor="let sent of sentProjectsList; let sentIndex = index">
                  <ng-container *ngIf="sentIndex <= 4">
                    <tr>
                      <td class="sub">
                        <div class="cUsrImg">
                          <span>{{ sent.subject }}</span>
                        </div>
                      </td>
                      <td class="status">
                        <p *ngIf="sent.status==0">Drafted</p>
                        <p *ngIf="sent.status==1">Mail Sent</p>
                        <p *ngIf="sent.status==2">In-progress</p>
                        <p *ngIf="sent.status==3">Completed</p>
                        <p *ngIf="sent.status==4">Withdraw</p>
                        <p *ngIf="sent.status==5">Declined</p>
                      </td>
                      <td class="act">
                        <button mat-icon-button (click)='OpenDetailsSent(sent)'>
                          <mat-icon>launch</mat-icon>
                        </button>
                      </td>
                    </tr>
                  </ng-container>
                  <tr *ngIf="sentIndex == 5">
                    <td colspan="3" class="viewall">
                      <a [routerLink]="'/esignature/sent'">View all</a>
                    </td>

                  </tr>
                </ng-container>


                <tr *ngIf="noRecordFoundSent">
                  <td class="noRecordFound" colspan="3">No Record Found</td>
                </tr>
              </table>
            </div>
          </div>

          <div class="group" *ngIf="ShowDraft">
            <div class="tabledata">
              <table cellspacing="0" cell padding="0">
                <tr>
                  <th class="sub bnone">Type</th>
                  <th class="sub bnone">Project Name</th>
                  <th class="status bnone">Steps</th>
                  <th class="act bnone">Link</th>
                </tr>
                <ng-container *ngFor="let draft of draftProjectsList; let draftIndex = index">
                  <tr *ngIf="draftIndex <= 4">
                    <td class="sub">
                      <img *ngIf="draft.projectType != 2" src="../../../../assets/images/icons/formIcon.svg" alt=""
                        width="30" />
                      <img *ngIf="draft.projectType == 2" src="../../../../assets/images/icons/form_tabuler.svg" alt=""
                        width="30" />
                    </td>

                    <td class="sub">
                      <div class="cUsrImg">
                        <span style="width: 150px;">{{ draft.projectName }}</span>
                      </div>
                    </td>
                    <td class="status">
                      <p class="showSteps" *ngIf="draft.projectType!= 2">
                        <ng-container *ngIf="draft.stepCompleted == 0 || draft.stepCompleted == 1">
                          <span class="active"></span>
                          <span></span>
                          <span></span>
                          <span></span>
                        </ng-container>
                        <ng-container *ngIf="draft.stepCompleted == 2">
                          <span class="active"></span>
                          <span class="active"></span>
                          <span></span>
                          <span></span>
                        </ng-container>
                        <ng-container *ngIf="draft.stepCompleted == 3">
                          <span class="active"></span>
                          <span class="active"></span>
                          <span class="active"></span>
                          <span></span>
                        </ng-container>
                        <ng-container *ngIf="draft.stepCompleted == 4">
                          <span class="active"></span>
                          <span class="active"></span>
                          <span class="active"></span>
                          <span class="active"></span>
                        </ng-container>

                      </p>
                      <p class="showSteps" *ngIf="draft.projectType== 2">
                        <ng-container>
                          <span class="active"></span>
                          <span class="active"></span>
                        </ng-container>
                      </p>
                    </td>
                    <td class="act">
                      <button *ngIf="draft.projectType != 2" mat-icon-button (click)='OpenProjectDeatils(draft)'>
                        <mat-icon>launch</mat-icon>
                      </button>
                      <button *ngIf="draft.projectType == 2" mat-icon-button (click)='OpenTablarDeatils(draft)'>
                        <mat-icon>launch</mat-icon>
                      </button>
                    </td>
                  </tr>
                  <tr *ngIf="draftIndex == 5">
                    <td colspan="3" class="viewall">
                      <a [routerLink]="'/esignature/draft'">View all</a>
                    </td>

                  </tr>
                </ng-container>

                <tr *ngIf="noRecordFounddraft">
                  <td class="noRecordFound" colspan="3">No Record Found</td>
                </tr>

              </table>
            </div>
          </div>
        </div>

      </mat-card>

      <mat-card class="group threeCGraph mt-10" style="margin-bottom: 20px;" >

        <div class="heading">
          <h3>Notes</h3>
          <button mat-icon-button color="primary" *ngIf="showNotesList" class="addNote"
            (click)="addNotes(addNotesDialog)">
            <mat-icon>add</mat-icon>
          </button>
          <mat-form-field appearance="" class="smdropdown">
            <mat-select value="0" [ngModel]="noteType" (selectionChange)="onSelectNoteFilter($event)">
              <mat-option value="0">All</mat-option>
              <mat-option value="2">Personal</mat-option>
              <mat-option value="1">Office</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="noteholder">

          <ng-container *ngFor="let notes of NotesList">
            <div class="noterow" *ngIf="notes.noteLevelID==2 ||notes.noteLevelID==3"
              [ngStyle]="{'background-color': notes.color }">

              <p innerHTML="{{notes.note}}"></p>
              <div class="nopt">
                <span> {{notes.createdOn+'Z'| date:'EEE, MMM d, y'}}</span>
                <span>
                  <button mat-icon-button color="basic" (click)="updateNotes(updateFolderDialog,notes)">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button mat-icon-button color="basic" (click)="DeleteNotes(notes)">
                    <mat-icon>delete_outline</mat-icon>
                  </button>
                </span>
              </div>
            </div>

            <div class="noterow" *ngIf="notes.noteLevelID==1"
              style="background: transparent; border: 2px dashed #3090fd;">

              <p innerHTML="{{notes.note}}"></p>
              <div class="nopt">
                <span> {{notes.createdOn+'Z'| date:'EEE, MMM d, y'}}</span>
                <span *ngIf="userId!=notes.createdBy"> By: {{notes.createdByFirstName}}
                  {{notes.createdByLastName}}</span>
                <span *ngIf="userId==notes.createdBy">
                  <button mat-icon-button color="basic" (click)="DeleteNotes(notes)">
                    <mat-icon>delete_outline</mat-icon>
                  </button>
                </span>
              </div>
            </div>
          </ng-container>
        </div>
        <div *ngIf="!showNotesList" class="addFirst">
          <button mat-icon-button color="primary" class="addNote" (click)="addNotes(addNotesDialog)">
            <mat-icon>add</mat-icon>
          </button>
          <p class="">Add your first note</p>
        </div>

      </mat-card>


    </div>

   
    <div class="recently dflexColSb">

      <mat-card class="threeCGraph mb15">


        <div class="core graph" *ngIf="coreGraphView">
          <div class="heading col">
            <div class="hview">
              <h3>3C</h3>
              <div class="view">
                <button mat-icon-button [ngClass]="{'active': coreListView}"
                  (click)="showListView()"><mat-icon>list</mat-icon></button>
                <button mat-icon-button [ngClass]="{'active': !coreListView}"
                  (click)="showGraphView()"><mat-icon>insert_chart</mat-icon></button>
              </div>
            </div>
            <div class="">
              <mat-form-field appearance="" style="margin-left: auto; margin-right: 15px;" class="smdropdown">
                <mat-select [ngModel]="SelectedCCC" (selectionChange)="CCCOptionSelect($event)">
                  <mat-option *ngFor="let list of CCCList" [value]="list.orgModuleName">
                    {{ list.orgModuleName }}
                  </mat-option>
                </mat-select>
                <!-- <mat-select value="Core" [ngModel]="SelectedCCC" (selectionChange)="CCCOptionSelect($event)">
                <mat-option value="Core">Core</mat-option>
                <mat-option value="Contact">Contact</mat-option>
                <mat-option value="Company">Company</mat-option>
              </mat-select> -->
              </mat-form-field>

              <mat-form-field appearance="" class="smdropdown">
                <mat-select value="Week" [ngModel]="SelectedWMY" (selectionChange)="CCCOptionSelectWMY($event)">
                  <mat-option value="Week">Week</mat-option>
                  <mat-option value="Month">Month</mat-option>
                  <mat-option value="Year">Year</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <div class="graphHere">
            <div class="#chart" *ngIf="chartOptions">
              <apx-chart [series]="chartOptions.series" [chart]="chartOptions.chart" [xaxis]="chartOptions.xaxis"
                [stroke]="chartOptions.stroke" [dataLabels]="chartOptions.dataLabels" [yaxis]="chartOptions.yaxis"
                [labels]="chartOptions.labels" [title]="chartOptions.title">
              </apx-chart>
            </div>

          </div>
        </div>

        <div class="core listing" *ngIf="coreListView">
          <div class="heading col">
            <div class="hview">
              <h3>Recently Created</h3>
              <div class="view">
                <button mat-icon-button [ngClass]="{'active': coreListView}"
                  (click)="showListView()"><mat-icon>list</mat-icon></button>
                <button mat-icon-button [ngClass]="{'active': !coreListView}"
                  (click)="showGraphView()"><mat-icon>insert_chart</mat-icon></button>
              </div>
            </div>
            <div class="filter_field">
              <!-- <mat-form-field appearance="" class="smdropdown">
                <mat-select [ngModel]="RecentlySelectedType" (selectionChange)="RecentlyCreatedSelect($event)">
                  <mat-option *ngFor="let list of CCCList" [value]="list.orgModuleName">
                    {{ list.orgModuleName }}
                  </mat-option>
                </mat-select>

              </mat-form-field> -->
              <div class="view threeButtons">
                <button class="btn" [ngClass]="{'active': currentCoreType == 'Core' }"
                  (click)="RecentlyCreatedSelect(orgModuleNameCore,'Core')">{{orgModuleNameCore}}</button>
                <button class="btn" [ngClass]="{'active': currentCoreType == 'Contact' }"
                  (click)="RecentlyCreatedSelect(orgModuleNameContact,'Contact')">{{orgModuleNameContact}}</button>
                <button class="btn" [ngClass]="{'active': currentCoreType == 'Company' }"
                  (click)="RecentlyCreatedSelect(orgModuleNameCompany,'Company')">{{orgModuleNameCompany}}</button>
              </div>
            </div>

          </div>

          <div class="group">
            <div class="tabledata">
              <table cellspacing="0" cell padding="0">
                <tr>
                  <th class="sub bnone">Name</th>
                  <th class="status bnone">Type</th>
                  <th class="act bnone">Action</th>
                </tr>
                <ng-container *ngFor="let rec of RecentlyCreatedCCCList; let recIndex = index">
                  <ng-container *ngIf="recIndex <= 3">
                    <tr>
                      <td class="sub">
                        <div class="cUsrImg" (click)="ViewProfile(rec)">
                          <span class="usrimg" *ngIf="rec.imageUrl"><img src="{{ rec.imageUrl }}" alt="carl" /></span>
                          <span class="shortName" *ngIf="!rec.imageUrl">{{ getShortName(rec.fieldValueName) }}</span>
                          <span>{{ rec.fieldValueName }}</span>
                        </div>
                      </td>
                      <td class="status" *ngIf="rec.fieldValueType">
                        {{ rec.fieldValueType }}
                      </td>
                      <td class="status" *ngIf="!rec.fieldValueType">
                        -
                      </td>
                      <td class="act">
                        <button mat-icon-button (click)="ViewProfile(rec)">
                          <mat-icon>launch</mat-icon>
                        </button>
                      </td>
                    </tr>
                  </ng-container>
                  <tr *ngIf="recIndex == 4">

                    <td colspan="3" class="viewall">
                      <a (click)="Viewall(rec)">View all</a>
                    </td>

                  </tr>
                </ng-container>

                <tr *ngIf="noRecordFoundCCC">
                  <td class="noRecordFound" colspan="3">No Record Found</td>
                </tr>
              </table>
            </div>
          </div>

        </div>


      </mat-card>

    </div>

    <div class="threeCGraph recently">
      <mat-card class="" style="padding: 0;" *ngIf="!isOnlyTaskView">
        <div class="heading col">
          <div class="hview">
            <h3>Tasks</h3>

            <div class="view">
              <button mat-icon-button [ngClass]="{'active': !isOnlyTaskView}"
                (click)="switchTaskView(false)"><mat-icon>task</mat-icon></button>
              <button mat-icon-button [ngClass]="{'active': isOnlyTaskView}"
                (click)="switchTaskView(true)"><mat-icon>format_list_bulleted</mat-icon>
              </button>
            </div>

          </div>
  
          <div class="view threeButtons">
            <button class="overdue" [ngClass]="{'active': currentType == 'Overdue' }"
              (click)="getTaskList('Overdue')">Overdue</button>
            <button class="today" [ngClass]="{'active': currentType == 'Today' }"
              (click)="getTaskList('Today')">Today</button>
            <button class="tomorrow" [ngClass]="{'active': currentType == 'Tomorrow' }"
              (click)="getTaskList('Tomorrow')">Tomorrow</button>
          </div>
        </div>
  
  
        <div class="group">         
            <div class="tabledata">
  
              <table cellspacing="0" cell padding="0">
                <tr>
                  <th class="sub bnone">Title</th>
                  <th class="act bnone">Action</th>
                </tr>
  
                <ng-container *ngFor="let item of taskList; let i = index">
                  <tr *ngIf="i <= 14">
                    <td class="sub">
                      {{item.taskTitle}}
                    </td>
                    <td class="viewall">
  
  
                      <ng-select (change)="onTaskListStatusChange($event,item)" formControlName="status{{item.taskId}}"
                        [searchable]="false" [clearAllText]="false" class="status_dropdown">  
  
                        <ng-option *ngFor="let stat of taskStatusList" [value]="stat.taskStatusID">
                          <span class="statusOptions" [style.background]="getBackground(stat.taskStatusID)">{{
                            stat.taskStatusName }}</span>
                        </ng-option>
  
                      </ng-select>
                    </td>
  
  
                  </tr>
                  <tr *ngIf="i == 15" class="viewall">
                    <td colspan="2" align="center"><a href="" routerLink="/task">View all</a></td>
                  </tr>
                </ng-container>  
  
                <div *ngIf="ShowNoRecordFound" class="noRecordFound">No Record Found</div>    
              </table>
  
            </div>          
        </div>
      </mat-card>

      <mat-card class="" style="padding: 0;"  *ngIf="isOnlyTaskView">
        <div class="heading col">
          <div class="hview">
            <h3>Tasklists</h3>
            <div class="view">
              <button mat-icon-button [ngClass]="{'active': !isOnlyTaskView}"
                (click)="switchTaskView(false)"><mat-icon>task</mat-icon></button>
              <button mat-icon-button [ngClass]="{'active': isOnlyTaskView}"
                (click)="switchTaskView(true)"><mat-icon>format_list_bulleted</mat-icon>
              </button>
            </div>
          </div>
  
          <div class="view twoButtons threeButtons taskListView">
            <button  [ngClass]="{'btn active': currentType == 'MyTaskList' }"
            (click)="getTaskListByType(1)">My Tasklists</button>
          <button [ngClass]="{'btn active': currentType == 'SharedTaskList' }"
            (click)="getTaskListByType(2)">Shared Tasklists</button>             
          </div>

        
        </div>
  
  
        <div class="group">         
            <div class="tabledata">
  
              <table cellspacing="0" cell padding="0">
                <tr>
                  <th class="sub bnone">Title</th>
                  <th class="act bnone">Action</th>
                </tr>
  
                <ng-container *ngFor="let item of taskList; let i = index">                
                  <tr *ngIf="i <= 14">
                    <td class="sub">
                     {{item.taskListName}}
                    </td>
                    <td class="viewall">                      
                      <div class="ilstButtons">
                        <button *ngIf="item.isMailSent==false && item.showSendMailMenu==true" mat-icon-button matTooltip="Send" (click)="MailToAssignee(item)"><mat-icon>email</mat-icon></button>
                        <!-- <span (click)="MailToAssignee(item)" *ngIf="item.isMailSent==false && item.showSendMailMenu==true">Send</span> -->
                        <button mat-icon-button matTooltip="Open" (click)="openInternalTaskList(item)"><mat-icon>launch</mat-icon></button>
                        <button mat-icon-button matTooltip="Open External URL" (click)="openTaskListUrl(item,true)"><mat-icon>link</mat-icon></button>            
                      </div>  
                    </td>
                  </tr>
                  <tr *ngIf="i == 15" class="viewall">
                    <td colspan="2" align="center"><a href="" routerLink="/task">View all</a></td>
                  </tr>
                </ng-container>
  
  
                <div *ngIf="ShowNoRecordFound" class="noRecordFound">No Record Found</div>
  
  
              </table>
  
            </div>         
        </div>
      </mat-card>

    </div>

  </div>

  <ng-template #addNotesDialog>
    <h2 mat-dialog-title>
      <span class="groupIcon"><mat-icon>speaker_notes</mat-icon></span>
      Add Note
      <button mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </h2>

    <mat-dialog-content>
      <form [formGroup]="addNotesForm">
        <mat-radio-group aria-label="" class="selectNote">
          <mat-radio-button color="primary" value="2" [checked]="PersonalChecked"
            (change)="selectNotes($event)">Personal</mat-radio-button>
          <mat-radio-button color="primary" value="1" [checked]="GlobalChecked" (change)="selectNotes($event)">Office
            (global for organization)</mat-radio-button>
          <mat-radio-button color="primary" value="3" [checked]="PortalChecked" (change)="selectNotes($event)">
            Portal</mat-radio-button>
        </mat-radio-group>

        <mat-form-field class="mt-10 noteh" appearance="fill">
          <mat-label>Add Note</mat-label>
          <textarea matInput placeholder="Write Note..." formControlName="notes"
            (ngModelChange)="onAddNoteCharCheck($event)" [maxlength]="maxChars"></textarea>
        </mat-form-field>
        <div class="charColor">
          <div class="colGroup">
            <ng-container *ngIf="PersonalChecked || PortalChecked">
              <ng-container *ngFor="let color of col; let i as index">
                <label class="colm" [ngStyle]="{'background-color': color.colname }">
                  <input type="radio" id="{{i}}" type="radio" value="{{color.colname}}" name="noteColor"
                    formControlName="color">
                  <span class="checkmark"></span>
                </label>
              </ng-container>
            </ng-container>

          </div>
          <label class="nopadding clrlbl"> Characters Remaining: {{maxChars - addnotes}}</label>
        </div>
      </form>
    </mat-dialog-content>
    <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
      <button mat-button color="basic" (click)="close()">Cancel</button>
      <button mat-flat-button color="primary" [disabled]="savebuttonshow" [disabled]="!addNotesForm.valid"
        (click)="AddNotes(addNotesForm.value)">Save
        <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
          </mat-spinner></mat-icon>
      </button>
    </mat-dialog-actions>
  </ng-template>


  <ng-template #updateFolderDialog>
    <h2 mat-dialog-title>
      <span class="groupIcon"><mat-icon>speaker_notes</mat-icon></span>
      Edit Note
      <button mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </h2>
    <mat-dialog-content>
      <form [formGroup]="addNotesForm">
        <mat-radio-group aria-label="" class="selectNote">
          <mat-radio-button color="primary" value="2" [checked]="PersonalChecked"
            (change)="selectNotes($event)">Personal</mat-radio-button>
          <mat-radio-button color="primary" value="1" [disabled]="true" [checked]="GlobalChecked"
            (change)="selectNotes($event)">Office (global for organization)</mat-radio-button>
          <mat-radio-button color="primary" value="3" [checked]="PortalChecked" (change)="selectNotes($event)">
            Portal</mat-radio-button>
        </mat-radio-group>

        <mat-form-field class="mt-10 noteh" appearance="fill">
          <mat-label>Add Note</mat-label>
          <textarea matInput placeholder="Write Note..." [(ngModel)]="notes"
            (ngModelChange)="onAddNoteCharCheck($event)" formControlName="notes"></textarea>
        </mat-form-field>


        <div class="charColor">
          <div class="colGroup">
            <ng-container *ngFor="let color of col; let i as index">
              <label class="colm" [ngStyle]="{'background-color': color.colname }">
                <input type="radio" id="{{i}}" type="radio" value="{{color.colname}}" name="noteColor"
                  formControlName="color">
                <span class="checkmark"></span>
              </label>
            </ng-container>
          </div>
          <label class="nopadding clrlbl"> Characters Remaining: {{maxChars - addnotes}}</label>
        </div>

      </form>
    </mat-dialog-content>
    <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
      <button mat-button color="basic" (click)="close()">Cancel</button>
      <button mat-flat-button color="primary" [disabled]="savebuttonshow" [disabled]="!addNotesForm.valid"
        (click)="AddNotes(addNotesForm.value)">Save
        <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
          </mat-spinner></mat-icon>
      </button>
    </mat-dialog-actions>
  </ng-template>


  <app-details *ngIf="showDetail"  [ngClass]="{ open: showDetail }" [transactionID]='transactionID'
  [modulenames]='mainModuleNameForDetails' [SendingFor]="sendFrom"
  (selectedCoreIdForSendTaskListUpdate)=getUpdatedRecord($event) (closeDetail)="getCloseDetails($event)">
  </app-details>


  <app-addnew *ngIf="showAddContact" (closeAdd)="getClose($event)" [modulename]='Module'
    [ngClass]="{'open': showAddContact}"></app-addnew>

  <app-addnew *ngIf="showAddCore" (closeAdd)="getCloseCore($event)" [name]="searchName" [isShared]="isShare"
    [mainModuleName]='mainModuleName' [modulename]='Module' [SendingFor]="sendFrom" [ngClass]="{'open': showAddCore}"
    (selectedCoreIdForSendTaskList)=getselectedTransactionId($event)>
  </app-addnew>

  <ng-template #SendTaskListURL>
    <h2 mat-dialog-title>
      <span class="groupIcon"><mat-icon>mail</mat-icon></span>
      Create and send tasklist
      <button mat-icon-button (click)="closeSendTaskListURL()">
        <mat-icon>close</mat-icon>
      </button>
    </h2>
    <mat-dialog-content>

      <ng-container *ngIf="showAuthenticationType">
        <div class="title">Send via {{orgModuleNameCore}}</div>

        <div class="authopt">
          <!-- <mat-radio-button value="1" [checked]="checkedByDefaultEmail" color="primary"
            (change)="getTokenEmail($event)">
            <div class="thisinfo emailauth" fxLayoutAlign="start center" fxLayout="row">
              <mat-icon>email</mat-icon>
              <h3>Email</h3>
            </div>
          </mat-radio-button>
          <mat-radio-button value="2" color="primary" (change)="getTokenMobile($event)">
            <div class="thisinfo smsauth" fxLayoutAlign="start center" fxLayout="row">
              <mat-icon>stay_current_portrait</mat-icon>
              <h3>SMS</h3>
            </div>
          </mat-radio-button>
          <mat-radio-button value="3" [checked]="checkedByDefaultCore" color="primary" (change)="getCorePanel($event)">
            <div class="thisinfo smsauth" fxLayoutAlign="start center" fxLayout="row">
              <mat-icon>app_registration</mat-icon>
              <h3>{{orgModuleNameCore}}</h3>
            </div>
          </mat-radio-button> -->
        </div>
      </ng-container>



      <!-- <div class="emailListHolder" *ngIf="SendMobileList.length > 0">
        <div class="emailList" *ngFor="let mobile of SendMobileList">

          <div class="info first">
            <span> Name</span>
            <p>{{mobile.name}}</p>

          </div>

          <div class="info">
            <span>Mobile</span>
            <p>{{mobile.mobile}}</p>
          </div>


          <button color="primary" class="close" mat-icon-button
            (click)="removeMobile(mobile.mobile)"><mat-icon>close</mat-icon></button>


        </div>
      </div>

      <div class="emailListHolder" *ngIf="SendEmailList.length > 0">
        <div class="emailList" *ngFor="let email of SendEmailList">

          <div class="info first">
            <span> Name</span>
            <p>{{email.name}}</p>

          </div>


          <div class="info">
            <span> Email</span>
            <p>{{email.emailid}}</p>

          </div>



          <button color="primary" class="close" mat-icon-button
            (click)="removeEmail(email.emailid)"><mat-icon>close</mat-icon></button>


        </div>
      </div> -->

      <div class="emailListHolder" *ngIf="selectCoreList.length > 0">
      <ng-container *ngFor="let email of selectCoreList">
        <div class="emailList">

          <div class="left">
            <div class="info first">
              <span> Name</span>
              <p>{{email.name}}</p>
            </div>
  
            <div class="info">
              <span> Email</span>
              <p>{{email.emailid}}</p>
            </div>
          </div>
          
          <div class="right">
            <div class="info assignto">
              <input type="checkbox"  (change)="onNotASignerChange($event, email)" [checked]="email.isNotASigner">
              <span> Assign to someone else</span>
              
            </div>
            
            <div class="act">
              <button color="primary" class="close" mat-icon-button
              (click)="editCore(email)">
              <mat-icon>edit</mat-icon>
            </button>
   
             <button color="primary" class="close" mat-icon-button
               (click)="removeCore(email.emailid)">
               <mat-icon>close</mat-icon>
             </button>
            </div>
           
          </div>


        </div>
        <div class="emailList" [id]="'1_Search' + email.emailid"  *ngIf="email.isNotASigner==true && email.contactAttachWithCores.length==0" >
          <div class="block mt-10 w100" >
            <mat-form-field appearance="outline" class="mt-10 mb-10" style="position: relative;">
              <mat-label>Search {{orgModuleNameContact}}</mat-label>
              <input matInput maxlength="50" placeholder="Type & Select" aria-label="State" [matAutocomplete]="autoContact"
                (input)="searchContacts($event.target.value)" [formControl]="stateCtrl" id="stateCtrlid">
              <mat-autocomplete #autoContact="matAutocomplete">
                <mat-option (click)="contactSelectedNew(contact,email.emailid)"
                  *ngFor="let contact of attachedToContactList" [value]="contact.name">
                  <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
                    <div class="userpic">
                      <img *ngIf="contact.imageUrl!=''" src="{{contact.imageUrl}}" alt="">
                      <span class="username" *ngIf="contact.imageUrl==''" class="username">
                        {{contact.shortName}}
                      </span>
                    </div>
                    <div class="info">
                      <p> {{ contact.name }}</p>
                      <p class="email">{{ contact.email }}</p>
                    </div>
                  </span>
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
           
          </div>
        </div>
        <div class="emailList"  [id]="'1_List' + email.emailid" *ngIf="email.isNotASigner==true && email.contactAttachWithCores.length>0" >
        
          <div class="left">
            <div class="info first">
              <span>{{orgModuleNameContact}} Name</span>
              <p>{{email.contactAttachWithCores[0].name}}</p>            
            </div>
                
            <div class="info">
              <span> Email</span>
              <p>{{email.contactAttachWithCores[0].email}}</p>            
            </div>
          </div>
              
         <div class="right"  >
          <div class="info" style="padding-right: 9px;" >
            <mat-select style="width: 150px;" (selectionChange)="OnChnageRelation($event,email)" value="0">
              <mat-option value="0">Select Relation</mat-option>
              <mat-option  *ngFor="let relation of relationList" [value]="relation.relationID">{{relation.relationName}}</mat-option> 
            </mat-select>
          </div>
              <button color="primary" class="close" mat-icon-button
                (click)="removeContactWithCoreCore(email)">
                <mat-icon>close</mat-icon>
              </button>
         </div>
         
        </div>
        
      </ng-container>
      </div>

      <!-- <div class="holderInput">

        <mat-form-field class="example-half-width" *ngIf="showSearchCore==false">
          <input type="text" maxlength="100" [(ngModel)]="name" matInput placeholder="Enter Name" />
        </mat-form-field>

        <div class="drive mainLink" *ngIf="showEmail">
          <mat-form-field class="example-half-width">
            <input type="text" [(ngModel)]="emailid" matInput placeholder="Enter Email" (keyup.enter)="AddEmail($event)"
              (input)="checkEmail($event.target.value)" />
            <button color="primary" *ngIf="addButtonShow" (click)="addEmails()" mat-mini-fab class="addUser">
              <mat-icon>add</mat-icon>
            </button>
          </mat-form-field>



        </div>

        <div class="drive mainLink" *ngIf="showMobile">
          <mat-form-field class="example-half-width">
            <input maxlength="10" matInput (keypress)="numberOnly($event)" [(ngModel)]="mobileNo" mask="(000) 000-0000"
              matInput placeholder="Enter Mobile No." (keyup.enter)="AddMobileNo($event)"
              (input)="checkMobileNo($event.target.value)" />
            <button color="primary" *ngIf="addButtonShow" (click)="addMobilesNo()" mat-mini-fab class="addUser">
              <mat-icon>add</mat-icon>
            </button>
          </mat-form-field>



        </div>
      </div> -->

      <!-- <div class="mb-10">
      <mat-checkbox *ngIf="selectCoreList.length > 0" style="font-size: 15px;" color="primary" [(ngModel)]="SendEmailLater" (change)="showOptions($event,'SendEmailLater')">Send Email Notification Later
      </mat-checkbox>
      </div> -->


      <div class="sepreator"></div>

      <div class="drive mainLink">
        <ng-container>
          <mat-form-field appearance="fill">
            <input matInput placeholder="Search {{orgModuleNameCore}}" [formControl]="stateCtrl"
              (input)="searchCore($event.target.value)" [matAutocomplete]="auto">
            <mat-autocomplete #auto="matAutocomplete">
              <mat-option (click)="coreSelected(core)" *ngFor="let core of attachedToCoreList" [value]="core.name">
                <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
                  <div class="userpic">
                    <img *ngIf="core.imageUrl!=''" src="{{core.imageUrl}}" alt="">
                    <span class="username" *ngIf="core.imageUrl==''" class="username">
                      {{core.shortName}}
                    </span>
                  </div>
                  <div class="info">
                    <p> {{ core.name }}</p>
                    <p class="email">{{ core.email }}</p>
                  </div>
                </span>
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </ng-container>
      </div>



    </mat-dialog-content>

    <div class="sepreator"></div>

    <mat-checkbox color="primary" [(ngModel)]="AssigneeChecked" (change)="showOptions($event,'Assignee')">Assign the
      same Users as template
    </mat-checkbox>&nbsp;

    <!-- <section class="wouldLike">
      <div class="info">
        <p class="textlimit">Select or deselect the options below</p>
      </div>
      <div class="checkBoxes">
 <mat-checkbox color="primary" [(ngModel)]="AttachChecked" (change)="showOptions($event,'Attach')">Attach the
          same person as template
        </mat-checkbox> &nbsp;
        
         &nbsp;
      </div>
       <mat-checkbox color="primary" [(ngModel)]="NotifyChecked" (change)="showOptions($event,'Notify')">Notify</mat-checkbox> 
    </section> -->

    <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
      <button mat-button color="basic" (click)="closeSendTaskListURL()">Cancel</button>

      <button mat-flat-button style="margin-left: 215px;" class="calltoaction" type="submit" color="primary"
        [disabled]="selectCoreList.length==0"
        (click)="SendEmailForTaskListURL(false)">
        Create & Send
        <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
          </mat-spinner></mat-icon>
      </button>

      <button mat-flat-button class="calltoaction" type="submit" color="primary"
        [disabled]="selectCoreList.length==0"
        (click)="SendEmailForTaskListURL(true)">
        Create Only
        <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
          </mat-spinner></mat-icon>
      </button>
    </mat-dialog-actions>

  </ng-template>




  <ng-template #AddLink>
    <h2 mat-dialog-title>
      <span class="groupIcon"><mat-icon>rocket_launch</mat-icon></span>
      Add Quick Link
      <button mat-icon-button (click)="closeSendTaskListURL()">
        <mat-icon>close</mat-icon>
      </button>
    </h2>
    <mat-dialog-content>


      <div>

        <mat-form-field appearance="outline">
          <mat-label>Icon name</mat-label>
          <input matInput placeholder="Icon name" id="urlname">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Add link </mat-label>
          <input matInput placeholder="Add link name" id="urllink">
        </mat-form-field>



        <!-- <input type="text" id="urlname" placeholder="Name">
    <input type="text" id="urllink" placeholder="Links"> -->

      <div class="iconNColor">
        <div class="selectedIcon" >
          <button mat-stroked-button color="primary" (click)="selectIcon()">
            Select Icon
          </button>
          <div *ngIf="formIcon!=''">
            <button mat-icon-button><mat-icon>{{formIcon}}</mat-icon></button>
          </div>
        </div>

        

        <div class="charColor" [formGroup]="addQuickLinkForm">
          <div class="colGroup">
            <ng-container *ngIf="PersonalChecked || PortalChecked">
              <ng-container *ngFor="let color of col; let i as index">
                <label class="colm" [ngStyle]="{'background-color': color.colname }">
                  <input type="radio" id="{{i}}" type="radio" value="{{color.colname}}" name="noteColor"
                    formControlName="quickLink">
                  <span class="checkmark"></span>
                </label>
              </ng-container>
            </ng-container>

          </div>
          <!-- <label class="nopadding clrlbl"> Characters Remaining: {{maxChars - addnotes}}</label> -->
        </div>

      </div>


        <!-- <div class="popup-buttons">
      <button style="padding: 8px 12px" class="cancel-btn" (click)="closePopup()">Cancel</button>
      <button style="padding: 8px 12px" class="save-btn" (click)="addDashboardQuicklink()">Save</button>
    </div> -->
      </div>


    </mat-dialog-content>


    <mat-dialog-actions class="mt-10" align="start" fxLayout="row" fxLayoutAlign="space-between center">
      <button mat-button color="basic" (click)="closeSendTaskListURL()">Cancel</button>
      <button mat-flat-button class="calltoaction" type="submit" color="primary" (click)="addDashboardQuicklink(addQuickLinkForm.value)">
        Save
        <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
          </mat-spinner></mat-icon>
      </button>
    </mat-dialog-actions>

  </ng-template>

  <app-loader></app-loader>